import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
export const Route = createFileRoute("/user/_layout/expense_/$id")({
  beforeLoad: () => requireFeature("expenses"),
  component: UserExpenseReportDetail,
});

import { ExpenseReportDetailPage } from "@/components/expense/ExpenseReportDetailPage";

function UserExpenseReportDetail() {
  const { id } = useParams({ from: "/user/_layout/expense_/$id" });
  return (
    <ExpenseReportDetailPage
      reportId={id}
      backUrl="/user/expense"
    />
  );
}
